import { render, staticRenderFns } from "./QualityControl.vue?vue&type=template&id=6dd220e6&scoped=true&"
import script from "./QualityControl.vue?vue&type=script&lang=js&"
export * from "./QualityControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd220e6",
  null
  
)

export default component.exports